export default __webpack_public_path__ + "static/media/ic-crops-bare-ground.183dcf24.svg";